import * as React from "react";
import { IProduct } from "~/types/product";
import ProductTile from "~/components/product-tile/product-tile";
import classNames from "classnames";
// import { IButtonAddToBasketProps } from "../button-add-to-basket/button-add-to-basket";
import Gallery from "../gallery/gallery";
import Anchor from "../anchor/anchor";
import { IDiscountOffer } from "~/types/discount-offer";

export interface IProductGalleryProps {
    products: IProduct[];
    secondaryPriceLabel?: string;
    disableCentering?: boolean;
    discountOffer?: IDiscountOffer;
    anchorId?: string;
    trackingList?: string;
}

const ProductGallery: React.FC<IProductGalleryProps> = ({
    products,
    // addToBasketWebApiUrl,
    // secondaryPriceLabel,
    trackingList,
    disableCentering,
    anchorId
}) => {
    const someProductsHaveStatus = products.some(product => !!product.status);
    // const someProductsHaveSubText = products.some(
    //     product => !!product.secondaryPrice || !!product.stockStatusLabel
    // );
    // const someProductsHaveNumberOfProductsLabel = products.some(product => !!product.numberOfProductsLabel);

    const baseClass = "product-gallery";
    const componentClasses = classNames(baseClass, {
        "anchor-wrapper": !!anchorId
    });
    const productListClasses = classNames(`${baseClass}__list`, {
        [`${baseClass}__list--isCentered`]: !disableCentering && products.length < 4
    });

    return (
        <section className={componentClasses}>
            {anchorId && <Anchor id={anchorId} />}
            <div className={`${baseClass}__inner`}>
                <div className={productListClasses}>
                    <Gallery isCentered={!disableCentering}>
                        {products.map((product, index) => (
                            <div key={product.productId} className={`${baseClass}__item`}>
                                <ProductTile
                                    {...product}
                                    className={`${baseClass}__product-tile`}
                                    hideBackground
                                    hideStatus={!someProductsHaveStatus}
                                    hasTopPadding={someProductsHaveStatus}
                                    // bottomPaddedSubText={someProductsHaveSubText}
                                    // hasBottomPaddingNumberOfProducts={someProductsHaveNumberOfProductsLabel}
                                    // ctaLabel={product.primaryPrice}
                                    // addToBasketWebApiUrl={addToBasketWebApiUrl}
                                    // secondaryPriceLabel={secondaryPriceLabel}
                                    ctaLink={undefined}
                                    sizes="(max-width: 480px) 150px, 100px"
                                    trackingList={trackingList || "Product Gallery"}
                                    trackingPosition={index + 1}
                                />
                            </div>
                        ))}
                    </Gallery>
                </div>
            </div>
        </section>
    );
};

export default ProductGallery;
